import { createEvent } from 'effector'
import { z } from 'zod'

import { RegisterInfoSchema } from '@portal/client-info'
import type { PortalProfile } from '@portal/portal-api'

import { parseJSONDate } from '../date-fns/parse-json-date'

export const login = createEvent<PortalProfile>()
export const registration = createEvent<{ supportId: string }>()
export const levelup = createEvent<{ level: number }>()
export const purchase = createEvent<{
    transactionId: string
    grossEUR: string
    grossUSD: string
    firstPurchase: boolean
}>()
export const pagehit = createEvent<PageHitPayload>()
export const storyStep = createEvent<{ label: string }>()

export const PageHitPayloadSchema = z.object({
    hit_time: z.string().transform(parseJSONDate),
    register_info: RegisterInfoSchema,
})

export type PageHitPayload = z.infer<typeof PageHitPayloadSchema>
